module.exports = __webpack_public_path__ + "static/media/IMG_20250208_194446.4053b9db.jpg";